import {matchPath} from 'react-router';
import Loadable from 'react-loadable';
import { version } from '../config';
import productRoute from './products';
import Loading from '../components/Loading';

// 业务页面
// import LoginPage from '../pages/LoginPage';
// import GroupManage from "../pages/GroupManagePage";
// import HomePage from '../pages/HomePage';
// import OrderList from '../pages/OrderListPage';
// import Couponaudit from '../pages/CouponauditPage';
// import MemberManage from '../pages/MemberManagPage';
// import StoreManagement from '../pages/StoreManagementPage';
// import PersonManage from '../pages/PersonManagePage';
// import ChannelList from '../pages/ChannelListPage';
// import AddInformation from '../pages/AddInfomationPage';
// import SecurityKeyList from '../pages/SecurityKayListPage';
// import MerchantInfo from '../pages/MerchantInfoPage';
// import AppList from '../pages/AppListPage';
// import SevriceType from '../pages/ServiceTypeMamagePage';
// import CouponDetail from '../pages/CouponDetailPage';
// import OrderDetail from '../pages/OrderDetailPage';
// import StoreUserList from '../pages/StoreUserListPage';
// import CouponUnAuditPage from '../pages/CouponUnAuditPage';
// import OrderRefundListPage from '../pages/OrderRefundListPage';
// import ServiceFollowUp from '../pages/ServiceFollowUp';
// import ServiceOrder from '../pages/ServiceOrder';
// import ProductKindsPage from '../pages/ProductKindsPage';
// import ProductBrandsPage from '../pages/ProductBrandsPage';
// import ProductListPage from '../pages/ProductListPage';
// import ProductSkuListPage from '../pages/ProductSkuListPage';
// import ProductSkuFileListPage from '../pages/ProductSkuFileListPage';
// import ProductSkuSizeListPage from '../pages/ProductSkuSizeListPage';
// import ProductPackageListPage from '../pages/ProductPackageListPage';
// import FeedBackListPage from '../pages/FeedBackListPage';
// import FeedBackFileListPage from '../pages/FeedBackFileListPage';
// import FeedBackDealListPage from '../pages/FeedBackDealListPage';
// import SettleAccountsPage from '../pages/SettleAccountsPage';
// import FeedBackDetailPage from '../pages/FeedBackDetailPage';
// import HookDemo from '../pages/DemoPage';
// import MempackageList from '../pages/MempackageList';
// import MempackageDetail from '../pages/MempackageDetail';
// import MemCouponList from '../pages/MemCouponList';
// import FeedApplyPreferList from '../pages/FeedApplyPreferList';
// import AddCouponApplyPage from '../pages/AddCouponApplyPage';
const routes = [
    {
        path: '/',
        exact: true,
        // component: LoginPage,
        component: Loadable({ loader: () => import('../pages/LoginPage'), loading: Loading }),
        title: '登录'
    },

    //首页
    {
        path:`/home/home/${version}`,
        // component:HomePage,
        component: Loadable({ loader: () => import('../pages/HomePage'), loading: Loading }),
        strict: true,
        exact: true,
        title:'首页',
    },{
        path:`/home/info/${version}`,
        // component:MerchantInfo,
        component: Loadable({ loader: () => import('../pages/MerchantInfoPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'商户信息'
    },{
        path:`/home/StorMan/${version}`,
        // component:StoreManagement,
        component: Loadable({ loader: () => import('../pages/StoreManagementPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'门店管理'
    },{
        path:`/home/PerMan/${version}`,
        // component:PersonManage,
        component: Loadable({ loader: () => import('../pages/PersonManagePage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'人员管理'
    },{
        path:`/home/groMan/${version}`,
        // component:GroupManage,
        component: Loadable({ loader: () => import('../pages/GroupManagePage'), loading: Loading }),
        strict: true,
        exact: true,
        title:'组管理',
    },{
        path:`/home/storeman/user/${version}`,
        // component:StoreUserList,
        component: Loadable({ loader: () => import('../pages/StoreUserListPage'), loading: Loading }),
        strict: true,
        exact: true,
        title:'门店用户管理',
    },{
        path:`/home/services/${version}`,
        // component:SevriceType,
        component: Loadable({ loader: () => import('../pages/ServiceTypeMamagePage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'服务类别管理'
    },


    //会员管理
    {
        path:`/member/MemMan/${version}`,
        // component:MemberManage,
        component: Loadable({ loader: () => import('../pages/MemberManagPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'会员列表'
    },
    {
        path:`/member/MempackageList/${version}`,
        // component:MempackageList,
        component: Loadable({ loader: () => import('../pages/MempackageList'), loading: Loading }),
        strict:true,
        exact:true,
        title:'会员商品礼包列表'
    },
    {
        path:`/member/MempackageDetail/${version}`,
        // component:MempackageDetail,
        component: Loadable({ loader: () => import('../pages/MempackageDetail'), loading: Loading }),
        strict:true,
        exact:true,
        title:'会员商品礼包分布详情'
    },
    {
        path:`/member/MemCouponList/${version}`,
        // component:MemCouponList,
        component: Loadable({ loader: () => import('../pages/MemCouponList'), loading: Loading }),
        strict:true,
        exact:true,
        title:'用户优惠券列表',
    },
    {
        path:`/member/level/${version}`,
        component: Loadable({ loader: () => import('../pages/MemberLevelPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'会员等级列表'
    },

    //营销管理
    {
        path:`/sale/Coupon/${version}`,
        // component:Couponaudit,
        component: Loadable({ loader: () => import('../pages/CouponauditPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'优惠券列表'
    },{
        path:`/sale/unauditCoupon/${version}`,
        // component:CouponUnAuditPage,
        component: Loadable({ loader: () => import('../pages/CouponUnAuditPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'待审核优惠券列表'
    },{
        path:`/sale/ConsulMan/${version}`,
        // component:ChannelList,
        component: Loadable({ loader: () => import('../pages/ChannelListPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'资讯管理'
    },{
        path:`/sale/ConsulMan/AddConsul/${version}`,
        // component:AddInformation,
        component: Loadable({ loader: () => import('../pages/AddInfomationPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'添加资讯'
    },
    {
        path:`/sale/coupon/detail/${version}`,
        // component:CouponDetail,
        component: Loadable({ loader: () => import('../pages/CouponDetailPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'优惠券详情'
    },

    //财务管理
    {
        path:`/order/orderlist/${version}`,
        // component:OrderList,
        component: Loadable({ loader: () => import('../pages/OrderListPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'财务管理'
    },{
        path:`/order/orderfefundlist/${version}`,
        // component:OrderRefundListPage,
        component: Loadable({ loader: () => import('../pages/OrderRefundListPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'退款订单列表'
    },{
        path:`/order/detail/${version}`,
        // component:OrderDetail,
        component: Loadable({ loader: () => import('../pages/OrderDetailPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'订单详情'
    },

    //应用管理
    {
        path:`/app/keylist/${version}`,
        // component:SecurityKeyList,
        component: Loadable({ loader: () => import('../pages/SecurityKayListPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'秘钥列表'
    },{
        path:`/app/applist/${version}`,
        // component:AppList,
        component: Loadable({ loader: () => import('../pages/AppListPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'应用管理'
    },
    // //服务跟进管理
    // {
    //     path:`/service/follow/${version}`,
    //     // component:ServiceFollowUp,
    //     component: Loadable({ loader: () => import('../pages/ServiceFollowUp'), loading: Loading }),
    //     strict:true,
    //     exact:true,
    //     title:'服务跟进管理'
    // },
    // {
    //     path:`/service/order/${version}`,
    //     // component:ServiceOrder,
    //     component: Loadable({ loader: () => import('../pages/ServiceOrder'), loading: Loading }),
    //     strict:true,
    //     exact:true,
    //     title:'预约列表'
    // },
    {
        path:`/feedback/feedbacklist/${version}`,
        // component:FeedBackListPage,
        component: Loadable({ loader: () => import('../pages/FeedBackListPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'反馈列表'
    },
    {
        path:`/feedback/feedbacklist/file/${version}`,
        // component:FeedBackFileListPage,
        component: Loadable({ loader: () => import('../pages/FeedBackFileListPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'反馈文件列表'
    },
    {
        path:`/feedback/deal/${version}`,
        // component:FeedBackDealListPage,
        component: Loadable({ loader: () => import('../pages/FeedBackDealListPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'反馈处理列表'
    },
    {
        path:`/order/settle/${version}`,
        // component:SettleAccountsPage,
        component: Loadable({ loader: () => import('../pages/SettleAccountsPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'收银台'
    },
    {
        path:`/feedback/deal/detail/${version}`,
        // component:FeedBackDetailPage,
        component: Loadable({ loader: () => import('../pages/FeedBackDetailPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'反馈处理详情'
    },
    {
        path:`/feedback/applylist/${version}`,
        // component:FeedApplyPreferList,
        component: Loadable({ loader: () => import('../pages/FeedApplyPreferList'), loading: Loading }),
        strict:true,
        exact:true,
        title:'优惠申请列表',
    },
    {
        path:`/feedback/addapply/${version}`,
        // component:AddCouponApplyPage,
        component: Loadable({ loader: () => import('../pages/AddCouponApplyPage'), loading: Loading }),
        strict:true,
        exact:true,
        title:'优惠申请',
    },
    ...productRoute,
    
];

export default routes;

const _matchRouteByPath = (pathname, parentPath, routeConfigs, matchResults) => {
    for (var i = 0; i < routeConfigs.length; i++) {
        const route = routeConfigs[i];
        const { path:routePath='' } = route;
        const path = `${parentPath}${routePath}`;
        const { exact, strict, children } = route;
        const match = matchPath(pathname, {
            path, exact, strict,
        });
        if (match) {
            matchResults.push({ match, route });
            if (children) {
                _matchRouteByPath(pathname, path, children, matchResults);
            }
            break;
        }
    }
};

export const matchRouteByPath = (path) => {
    const matchResults = [];
    _matchRouteByPath(path, '', routes, matchResults);
    return matchResults;
};

export const getRouteChildrenByPath = (path) => {
    let matchResults = matchRouteByPath(path);
    matchResults = matchResults.filter(r => r.match.url === path && r.route.path);
    const last = matchResults[matchResults.length-1];
    const { children } = last.route;
    return children;
};



// WEBPACK FOOTER //
// ./src/routes/index.js